// @flow
import creditCardIcon from 'assets/credit-card.svg'
import StripeForm from 'components/Billing/StripeForm'
import Spinner from 'components/Spinner'
import { useLoadBilling } from 'queries/payments/useLoadBilling'
import * as React from 'react'
import { toast } from 'react-toastify'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import Modal from 'ui/atoms/Modal'
import Table from 'ui/atoms/Table'
import Text from 'ui/atoms/Text'
import { ZentakeContext } from 'utils/ZentakeContext'

import {
  invalidateLoadStripeCustomer,
  useLoadStripeCustomer,
} from '@/queries/payments/useLoadStripeCustomer'

function PaymentMethod(): React.Node {
  const { data, isLoading, refetch } = useLoadBilling()
  const [showUpdatePaymentMethodModal, setShowUpdatePaymentMethodModal] =
    React.useState(false)
  const { data: stripeCustomer } = useLoadStripeCustomer()
  const { updateUserDetails } = React.useContext(ZentakeContext)

  React.useEffect(() => {
    updateUserDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <FlexBox className="max-w-2xl">
        <Table.Title>
          <Flex align="center" className="w-full" justify="between">
            <Text>Payment Method</Text>
            <Text
              $active
              className="cursor-pointer"
              onClick={() => setShowUpdatePaymentMethodModal(true)}
            >
              Update Payment Method
            </Text>
          </Flex>
        </Table.Title>
        <Table>
          <Table.Body>
            <Table.Row>
              {isLoading ? (
                <Table.Column>
                  <Spinner color="onLight" />
                </Table.Column>
              ) : (
                <>
                  {data?.card ? (
                    <>
                      <Table.Column>
                        <Flex align="center">
                          <img
                            alt="credit-card-icon"
                            className="mr-2 h-5"
                            src={creditCardIcon}
                          />
                          <Text>{data.card.brand}</Text>
                        </Flex>
                      </Table.Column>
                      <Table.Column>
                        <Text>**** **** **** {data.card.last4}</Text>
                      </Table.Column>
                      <Table.Column>
                        <Text>
                          Exp. {data.card.exp_month}/{data.card.exp_year}
                        </Text>
                      </Table.Column>
                    </>
                  ) : (
                    <Table.Column>
                      <Flex align="center">
                        <Text>
                          You haven't added any billing information yet.
                        </Text>
                        <Text $active className="cursor-pointer">
                          Choose a plan
                        </Text>
                      </Flex>
                    </Table.Column>
                  )}
                </>
              )}
            </Table.Row>
          </Table.Body>
        </Table>
      </FlexBox>
      {showUpdatePaymentMethodModal && (
        <Modal
          closeButton
          show
          onHide={() => setShowUpdatePaymentMethodModal(false)}
        >
          <StripeForm
            onChange={() => {
              setTimeout(() => {
                refetch()
                  .then(async () => {
                    await invalidateLoadStripeCustomer()
                    await updateUserDetails()
                  })
                  .catch(() => {
                    toast.error('Failed to retrieve updated payment method')
                  })
              }, 2000)
            }}
            stripeCustomer={stripeCustomer}
            title="Update card details"
          />
        </Modal>
      )}
    </>
  )
}

export default PaymentMethod
